export default {
    list: {
        title: "Refunds",
        name: 'refunds',
        class: "min-h-screen flex-1 mt-1 bg-gray-100 px-3 items-center",
        sousTable: true,
        options: {
            defaultPageSize: 5,
            actions: {
                isActive: true,
                name: "Actions",
                buttons: [{
                        text: "New refund",
                        icon: "add",
                        link: '/refunds/new',
                        color: 'primary'
                    }
                ],
            }
        },
        columns: [
            {
                name: "ID",
                elements: [{
                    items: [{
                        name: "id",
                        class: "text-center",
                    }, ],
                }, ]
            },
            {
                name: "Order ID",
                elements: [{
                    items: [{
                        class: "ouka",
                        name: "ObjetDetails",
                        elements: [{
                            items: [{
                                    name: "orderId",
                                    class: "font-bold text-gray-700",
                                    
                                },
                            ]
                        }]

                    }, ],
                }, ]
            },
            {
                name: "Seller",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "ObjetDetails",
                        elements: [{
                            items: [{
                                    name: "fullName",
                                    class: "font-bold text-gray-700",
                                    
                                },
                            ]
                        }]
                    }],
                }, ]
            },
            {
                name: "Products",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "ObjetDetails",
                        elements: [{
                            items: [{
                                    name: "products",
                                    class: "font-bold text-gray-700",
                                    
                                },
                            ]
                        }]
                    }],
                }, ]
            },
            {
                name: "Refund",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        name: "ObjetDetails",
                        elements: [{
                            items: [{
                                    name: "totalPrice",
                                    class: "font-bold text-gray-700",
                                    
                                },
                            ]
                        }]
                    }],
                }, ]
            },
            {
                name: "Date accepted",
                class: "",
                elements: [{
                    items: [{
                        class: "",
                        date: true,
                        name: "acceptedAt",
                        type: "text",
                    }],
                }, ]
            },
            {
                name: "Status",
                class: "",
                elements: [{
                    items: [{
                        class: "border capitalize rounded-full text-gray-600 h-8 text-xs px-8 bg-white hover:border-gray-500 focus:outline-none appearance-none",
                        name: "status",
                        options: (item) => {
                            switch (item) {
                                case 'pending':
                                    return "color: rgb(233 147 19); border-color: rgb(233 147 19);"
                                    break;
                                case 'accepted':
                                    return "color:rgb(8, 194, 226); border-color: rgb(8, 194, 226);"
                                    break;
                                case 'effectue':
                                    return "color:rgb(58 217 18); border-color: rgb(58 217 18);"
                                    break;
                                case 'processed':
                                        return "color:rgb(18 23 217); border-color: rgb(18 23 217);"
                                        break;
                                  
                                case 'rejected':
                                    return "color: rgb(255, 5, 5); border-color: rgb(255, 5, 5);"
                                    break;
                            }
                        },
                    }],
                }, ]
            },
        ],
        actions: {
            name: "Actions",
            width: "10px",
            class: "justify-end",
            elements: [
                {
                    icone: "remove_red_eye",
                    color: "success",
                    key: 'read',
                    id: "",
                    role: true,
                    link: '/refunds/view',
                    tooltip: "Update",
                },
                {
                    icone: "delete",
                    color: "danger",
                    role: true,
                    key: 'delete',
                    tooltip: "Delete",
                }
            ],
        },
        filters: {
            name: 'refunds',
            hasFilterdate:true,
            elements: {
                search: {
                    options: {
                        icon: "search",
                        label: "search",
                        class: "",
                        hint: "ID, id order, Custumer name ...",
                    },
                    value: null,
                    type: "search",
                    validate: {
                        trim: true,
                        required: false,
                        minlength: 0,
                    }
                },
                champs: [
                    {
                        label: "Seller",
                        key: "seller",
                        name: "fullName",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                    {
                        label: "Status",
                        key: "status",
                        name: "name",
                        value: null,
                        values: [],
                        class: 'py-2 text-xs  capitalize px-2 outline-none block h-full w-full bg-white',
                        type: "select",
                    },
                ],
            },
        },
    },
}
